// Handles updating the cart icon when cart is updated
document.addEventListener('DOMContentLoaded', function () {
  if (window.subscribe) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
      const cartRes = await fetch('/cart.js');

      if (!cartRes.ok) {
        publish(PUB_SUB_EVENTS.notification, {
          source,
          error: 'Error: Network response was not ok',
        });
      }

      const cart = await cartRes.json();

      if (!cart) {
        publish(PUB_SUB_EVENTS.notification, {
          source,
          error: 'Error: Failed to retrieve cart',
        });
      }

      // Icon colors
      const cartIcon = document.getElementById('moia-cart-icon-anchor');
      const fontColorClass = cartIcon.getAttribute('data-font-color-class');
      const fontColorBgClass = cartIcon.getAttribute('data-font-color-bg-class');
      const fontCartQtyClass = cartIcon.getAttribute('data-font-cart-qty-class');

      // Update cart icon
      await sectionReplace({
        sectionQuery: '/?sections=moia-navigation-header',
        sectionName: 'moia-navigation-header',
        mainAnchorId: 'moia-cart-icon-anchor',
        targetAnchorId: 'moia-cart-icon-anchor-target',
        targetedClassUpdates: [
          {
            selector: '.moia-svg-cart.moia-color-blue',
            classDefault: 'moia-color-blue',
            classReplace: fontColorClass,
          },
          {
            selector: '.moia-cart-count-bubble.moia-color-bg-blue',
            classDefault: 'moia-color-bg-blue',
            classReplace: fontColorBgClass,
          },
          {
            selector: '.moia-cart-count-bubble .moia-color-white',
            classDefault: 'moia-color-white',
            classReplace: fontCartQtyClass,
          },
        ],
      });
    });
  }
});
